module.exports = __webpack_public_path__ + "9ca557ebd561352b71256e8e071d8f88.jpg";